export enum Genders {
  Male,
  Female,
}
export enum InviteStatus {
  Invited = 'invited',
  NotInvited = 'not_invited',
  InviteAccepted = 'active',
}

export enum Relations {
  Father,
  Mother,
  Guardian,
  StepFather,
  StepMother,
  Grandparent,
  OtherRelative,
  PersonalAssistant,
  PersonalTutor,
  Driver,
  DomesticHelper,
  Sibling,
  HalfSibling,
  StepSibling,
  Other,
}

export enum RelationsToChild {
  Mother = 1,
  Father,
  StepMother,
  StepFather,
  Aunt,
  Uncle,
  Grandmother,
  Grandfather,
  Brother,
  Sister,
  Cousin,
  LegalGuardian,
}

export enum Titles {
  Mr,
  Mrs,
  Miss,
  Ms,
  Dr,
  Prof,
}

export enum PersonTypes {
  Staff,
  Student,
  Parent,
}

export enum StaffStatuses {
  Applicant,
  Employed,
  Left,
}

export enum StudentStatuses {
  Applicant,
  Enrolled,
  Left,
}

export enum SchoolInviteStatus {
  Invited,
  Active,
}
